import React from 'react';
import cn from 'classnames';
import styles from './FilterItemContent.module.scss';

const FilterItemContent = ({ rootClassName, text, amount, postText }) => {
  return (
    <div className={cn(styles.root, rootClassName)}>
      <div style={{ maxWidth: '250px' }}>
        {text} {postText && <span className={styles.postText}>{`(${postText})`}</span>}
      </div>
      <span>{amount}</span>
    </div>
  );
};

export default FilterItemContent;
